import React, {useState} from 'react';
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import TextFieldWithErrorMessage from "../form/TextFieldWithErrorMessage";
import {Box, Button} from "@material-ui/core";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {AUTH_PAGE_MENU} from "../../pages/AuthPage";
import {forgotPassword} from "../../api/AuthenticationEndpoints";
import {RR_STATUS} from "../../constants/RRConstants";

const validationSchemaStageOne = Yup.object({
    username: Yup.string()
        .max(100, "form.request-password.error.username-max-limit")
        .required("form.request-password.error.username-required", true)
});

const validationSchemaStageTwo = Yup.object({
    email: Yup.string()
        .max(100, "form.request-password.error.email-max-limit")
        .email("form.request-password.error.email")
        .required("form.request-password.error.email", true),
});

const RequestPasswordForm = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const [stage, setStage] = useState(1);
    const isStageOne = () => {
        return stage === 1;
    };

    return (
        <Formik
            initialValues={{
                username: "",
                email: ""
            }}
            validationSchema={() => isStageOne() ? validationSchemaStageOne : validationSchemaStageTwo}
            onSubmit={(values) => {
                if (isStageOne()) {
                    setStage(2);
                } else {
                    forgotPassword(values.username, values.email).then(({data}) => {
                        const {status, message} = data;
                        let response = status === RR_STATUS.OK;

                        navigate(
                            {
                                search: `menu=${AUTH_PAGE_MENU.RESET_PASSWORD}&success=${response}`
                            },
                            {
                                state: { message }
                            }
                        );
                    });
                }

            }}
        >
            {() => (
                <Form>
                    {isStageOne() ?
                        <Field component={TextFieldWithErrorMessage} name={"username"}
                               caption={"form.request-password.username"}
                               required variant={"outlined"} size={"small"} disabled={!isStageOne()}/> :
                        <Field component={TextFieldWithErrorMessage} name={"email"}
                               caption={"form.request-password.email"}
                               required variant={"outlined"} size={"small"} disabled={isStageOne()}/>
                    }
                    <Box my={2}>
                        {isStageOne() ?
                            <Button variant={"contained"} color={"primary"} fullWidth
                                    type="submit">{t("core.next")}</Button> :
                            <Button variant={"contained"} color={"primary"} fullWidth
                                    type="submit">{t("buttons.request-new-password")}</Button>
                        }
                    </Box>
                    <Button variant={"contained"} fullWidth onClick={() => {
                        navigate(-1);
                    }}>{t("core.close")}</Button>
                </Form>)}
        </Formik>
    )
};

export default RequestPasswordForm;